<template>
  <CColor :theme>
    <CIcon :name/>
  </CColor>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import CColor from '@/shared/components/CColor.vue';
  import CIcon from '@/shared/components/CIcon.vue';
  import StockStatus from '../constants/StockStatus';

  const props = defineProps<{
    status: StockStatus | null;
  }>();

  const theme = computed(() => {
    switch (props.status) {
      case StockStatus.OUT_OF_STOCK:
        return 'danger';
      case StockStatus.IN_ORDER:
        return 'warning';
      case StockStatus.IN_STOCK:
        return 'success';
      default:
        return 'neutral';
    }
  });

  const name = computed(() => {
    switch (props.status) {
      case StockStatus.OUT_OF_STOCK:
        return 'x-circle';
      case StockStatus.IN_ORDER:
        return 'hourglass';
      case StockStatus.IN_STOCK:
        return 'check-circle';
      default:
        return 'minus-double';
    }
  });
</script>